import { DataBean } from "../DataBean";


export class DOCDocument extends DataBean {

    public async getDOCDocument(iddocdocument: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocument_getDOCDocument_Number", [iddocdocument]);
    }

    public async getDOCDocumentCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCDocumentCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCDocument(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCDocument_updateDOCDocument_com.advantage.forms.bean.DOCDocument", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCDocument"
            }
        ]);
    }

}
